import { render, staticRenderFns } from "./VOffers.vue?vue&type=template&id=65d397c0"
import script from "./VOffers.vue?vue&type=script&lang=js"
export * from "./VOffers.vue?vue&type=script&lang=js"
import style0 from "./VOffers.vue?vue&type=style&index=0&id=65d397c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@babel+core@8.0.1_@vue+compiler-sfc@3.5.43_css-loader@6.11.0_webpack_3967ed8cd784b60b7f0fd1a71945913e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports